module.exports = __webpack_public_path__ + "img/Back.3a3c5f9.png";